import o from"store2";const t=()=>o.namespace("ethos")("configuration")||{};var a=t;export{a as default};
